module.exports = __webpack_public_path__ + "img/credito-1.2ca83076.webp";